import { gql } from '@zenbusiness/application-commons-graphql';

export const GET_APPLICATION_QUERY = gql`
  query Application($input: ApplicationInput!) {
    application(input: $input) {
      address {
        street
        street2
        city
        state
        postalCode
        country
      }
      accountOwner {
        address {
          street
          street2
          city
          state
          postalCode
          country
        }
      }
      name
    }
  }
`;

export const GET_APPLICATION_DOCS_STATUS_QUERY = gql`
  query ApplicationDocsStatus($input: ApplicationInput!) {
    application(input: $input) {
      status
    }
  }
`;

export const GET_APPLICATION_ADDITIONAL_INFO_QUERY = gql`
  query ApplicationAdditionalInfo($input: ApplicationInput!) {
    application(input: $input) {
      entityType
      businessIndustry
      accountPurpose
      sourceOfFunds
      transactionVolume
      isRegulated
      usNexus
    }
  }
`;
